import React from "react";
import styled from "styled-components";
import SelfServiceReport from "../interfaces/SelfServiceReport";
import ReportCard from "./ReportCard";

const Container = styled.div`
  p {
    text-align: center;
    font-family: Inter, system-ui;
    font-weight: 400;
    font-size: 19px;
    line-height: 25px;
    margin: 0;
    color: #84838d;

    &:first-child {
      margin-top: 4vh;
    }
  }
`;

interface PersonalReportListProps {
  ownerId: string;
  searchQuery: string;
  reports: SelfServiceReport[];
  editReport: (selfServiceReportId: string) => void;
  duplicateReport: (report: SelfServiceReport) => Promise<void>;
  deleteReport: (selfServiceReportId: string) => Promise<void>;
}

const PersonalReportList = (props: PersonalReportListProps) => {
  const { searchQuery, reports } = props;

  if (reports.length === 0) {
    if (Boolean(searchQuery)) {
      return (
        <Container>
          <p>Clear the filter to see all your templates.</p>
        </Container>
      );
    }

    return (
      <Container>
        <p>Welcome to Self Service Reports!</p>
        <p>Create a report template to see it reflected here.</p>
        <p>Use your templates to easily view and analyze your data.</p>
      </Container>
    );
  }

  return (
    <Container>
      {reports.map((r) => (
        <ReportCard
          key={r.selfServiceReportId}
          report={r}
          editReport={props.editReport}
          duplicateReport={props.duplicateReport}
          deleteReport={props.deleteReport}
        />
      ))}
    </Container>
  );
};

export default PersonalReportList;
